import { useParams } from 'react-router-dom';
import EstateAdministration from './EstateAdministration';
import GrantApplication from './GrantApplication'
import LastingPowerOfAttorney from './LastingPowersofAttorney';
import LssEstateAdministration from './LssEstateAdministration';
import LssGrantApplication from './LssGrantApplication';
import LssLastingPowerOfAttorney from './LssLastingPowersofAttorney';
import LssWills from './LssWill';
import Wills from './Will';
import Conveycing from './Conveyancing'


export const PartnerTables = () => {
    const { title } = useParams();

    if (title == 'estate-administration') {
        return <EstateAdministration />;
    }
    if (title == 'conveyancing') {
        return <Conveycing />;
    }
    if(title == 'grant-application'){
        return <GrantApplication/>;
    }
    if(title == 'lasting-powers-of-attorney'){
        return <LastingPowerOfAttorney/>;
    }
    if(title == 'lss-estate-administration'){
        return <LssEstateAdministration/>;
    }
    if(title == 'lss-grant-application'){
        return <LssGrantApplication/>;
    }
    if(title == 'lss-lasting-powers-of-attorney'){
        return <LssLastingPowerOfAttorney/>;
    }
    if(title == 'lss-will'){
        return <LssWills/>;
    }
    if(title == 'will'){
        return <Wills/>;
    }

    return null;
};
